
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/client/login",
      function () {
        return require("private-next-pages/client/login/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/client/login"])
      });
    }
  